import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { AuthserviceService } from './authservice.service';
import { ApiConstants } from 'src/app/constants/api-constants';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, finalize } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';
import { AlertDialogComponent } from '../shared/components/alert-dialog/alert-dialog.component';
import { environment } from 'src/environments/environment';
import { DataService, LoaderHandlerService, ServicecallService } from 'src/app/services';
import { DatePipe } from '@angular/common';

@Injectable()
export class networkInterceptor implements HttpInterceptor {
  isDialogActive: boolean = false;
  _dataServiceSubscription: Subscription;
  widgetStartEndDate: any ;
  widgetRangeSelected: string;
  entitiesListStartEndDate: any;

  
  constructor(public auth: AuthserviceService, private router: Router,private _datePipe: DatePipe,
    private dataService: DataService,
    private loaderHandler: LoaderHandlerService, public dialog: MatDialog, public service: ServicecallService,) {
      this._dataServiceSubscription = this.dataService.events.subscribe((res: any) => {
        if (res.name === 'dateTimeRangeApplied') {
          this.widgetStartEndDate = res?.args?.[0];
          this.widgetRangeSelected = res?.args?.[1]?.rangeSelected;
        } 
        if(res.name === 'entitiesListingdateApplied') {
          this.entitiesListStartEndDate = res?.args?.[0];
        }
      });
     }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.auth.getToken();
    let tenantId = this.auth.getTenantId();
    let appId = ApiConstants.appId;
    const userId = localStorage.getItem('userId') ? localStorage.getItem('userId') : null;
    this.dataService.broadcast('updateRefreshTimer');
    // setTimeout(() => {if(true){
    // if (!this.auth.isLoaderNeeded(request.url))
    //   this.loaderHandler.toggleLoader(1);
    // }},1)
    // if (!request.url.includes('nsclusterhdistorage.blob.core.windows.net')) {
    //   request = request.clone({
    //     url: environment['API_ENDPOINT'] + request.url
    //   });
    // }
    if (request.url.includes(environment?.azureBlobBaseUrl)) {
      request = request.clone({
        setHeaders: {
          'x-ms-blob-type': 'BlockBlob',
          'X-Frame-Options': 'SAMEORIGIN',
          'X-Content-Type-Options': 'nosniff',
        }
      });
    } else if ((request.url.includes('/external') && !request.url.includes('/external/chatRequest')) || request.url.includes('auth/authentication')) {
      token = ApiConstants.appToken;
      request = request.clone({
        setHeaders: {
          'x-access-token': `${token}`,
          'appId': `${appId}`,
          'X-Frame-Options': 'SAMEORIGIN',
          'X-Content-Type-Options': 'nosniff',
        }
      });
    }
    else if (request.url.includes('/changePassword') || request.url.includes('/resetPassword')) {
      token = ApiConstants.appToken;
      request = request.clone({
        setHeaders: {
          'x-access-token': `${token}`,
          'appId': `${appId}`,
          'tenantId': `${tenantId}`,
          'userId': `${userId}`,
          'X-Frame-Options': 'SAMEORIGIN',
          'X-Content-Type-Options': 'nosniff',
        }
      });
    }
    else {
      if (token) {
        request = request.clone({
          setHeaders: {
            'x-access-token': `${token}`,
            'tenantId': `${tenantId}`,
            'userId': `${userId}`,
            'X-Frame-Options': 'SAMEORIGIN',
            'X-Content-Type-Options': 'nosniff',
          }
        });
      }
      else {
        if (this.router.url.includes('/signup')) {
          token = ApiConstants.appToken;
          request = request.clone({
            setHeaders: {
              'x-access-token': `${token}`,
              'appId': `${appId}`,
              'X-Frame-Options': 'SAMEORIGIN',
              'X-Content-Type-Options': 'nosniff',
            }
          });
        }
        else if (this.router.url.includes('/login')) {
          token = ApiConstants.appToken;
          request = request.clone({
            setHeaders: {
              'x-access-token': `${token}`,
              'X-Frame-Options': 'SAMEORIGIN',
              'X-Content-Type-Options': 'nosniff',
            }
          });
        }
      }

    }
  
    //To intercept dashboard apis with selected date-time range
    if (request.headers.has('page-type') && (request.headers.get('page-type') === 'widget' || request.headers.get('page-type') === 'widget-state')) {
      request = request.clone({
        body: { ...request.body, ...((request.headers.get('page-type') !== 'widget-state' && request.headers.get('page-type') !== 'widgetTfs') && {from: this.widgetStartEndDate?.startDate}) , to: this.service.getDateState('global')?.range === 'Yesterday' || this.service.getDateState('global')?.range === 'Custom' ? this.widgetStartEndDate?.endDate :  
        this._datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ssZZ') }
      });
    } else if (request.headers.has('page-type') && (request.headers.get('page-type') === 'widgetDTCCount')) {
      request = request.clone({
        body: { ...request.body, range : {from: this.widgetStartEndDate?.startDate , to: this.service.getDateState('global')?.range === 'Yesterday' || this.service.getDateState('global')?.range === 'Custom' ? this.widgetStartEndDate?.endDate :  
        this._datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ssZZ') }}
      });
    }

    //To intercept vehicle list apis with selected date-time range
    if (request.headers.has('page-type') && (request.headers.get('page-type') === 'vehicleList' || request.headers.get('page-type') === 'vehicle-list')) {
      request = request.clone({
        body: { ...request.body, from: this.entitiesListStartEndDate?.startDate , to: this.entitiesListStartEndDate?.endDate }
      });
    } else if (request.headers.has('page-type') && (request.headers.get('page-type') === 'activeDtcCount')) {
      request = request.clone({
        body: { ...request.body,  range: {from: this.entitiesListStartEndDate?.startDate, to: this.entitiesListStartEndDate?.endDate} } });
    }
    if (request.url.includes('/v4/entities/bulkUpload') || request.url.includes('/v3/entities/export') ) {
      const siteId = this.service.getSiteId();
      if (siteId) {
        request = request.clone({
          setHeaders: {
            'siteId': siteId 
          }
        });
      }
    }

    //for timezone change
    const body = request?.body;
    if (body && (body?.from || body?.to || body?.range?.from || body?.range?.to)) {
      request = request.clone({
        body: {
          ...body,
          ...(body?.from && { from: this.dataService.convertToTimeZone(body?.from) }),
          ...(body?.to && { to: this.dataService.convertToTimeZone(body?.to) }),
          ...(body?.range && (body?.range?.from || body?.range?.to) && {
            range: {
              ...body?.range,
              ...(body?.range?.from && { from: this.dataService.convertToTimeZone(body?.range?.from) }),
              ...(body?.range?.to && { to: this.dataService.convertToTimeZone(body?.range?.to) }),
            }
          }),
        }
      });
    }
    return next.handle(request).pipe(
      finalize(() => this.loaderHandler.toggleLoader(0)),
      catchError((error: HttpErrorResponse) => {
        let errorMsg = ''; let errorType = null;
        if (error && error.error) {
          if (error.status && error?.error && error?.error?.message) {
            // Error Code: ${error.status},
            errorMsg = `${error.error.message}`;
            errorType = error?.error?.errorType ? error?.error?.errorType : null;
          } else if (error?.status && error?.error?.response && error?.error?.response?.message) {
            // Error Code: ${error.status},
            errorMsg = `${error.error.response.message}`;
            errorType = error.error.response?.errorType ? error.error.response?.errorType : null;
          } else {
            errorMsg = `Error Code: ${error.status}, Message:${error.statusText}`;
            errorType = null;
          }
        } else {
          errorMsg = `Error Code: ${error.status}, Message:${error.statusText}`;
          errorType = null;
        }

        if (error.status === 403) {
          this.dataService.broadcast('tenantExpired');
          this.handleAuthError(errorMsg);
        } else if (error.status === 401 && errorType === 1) {
          this.dataService.broadcast('sessionTimeout');
          this.handleAuthError();
        } else {
          if (error?.url?.includes('/external/chatRequest')) {
            return throwError(() => errorMsg)
          } else if (!error?.url?.includes('/entities/entityData') || !error?.url?.includes('/v1/entities') || !error?.url?.includes('/alerts/alertsCountList')) {
            if(error?.url?.includes('/cases/protus')) {
              this.service.toasterService({ type: 'error', msg: error?.error?.tag ? `${error?.error?.tag} - ${errorMsg}` : errorMsg })
            } else {
              this.service.toasterService({ type: 'error', msg: errorMsg });
            }
          }
        }
        // this.toastr.error(errorMsg);
        (error as any).friendlyMessage = errorMsg;

        return throwError(() => (request.headers.has('page-type') && request.headers.get('page-type') === 'bulk-upload') ? error : errorMsg);
      }));
  }

  /**
* Handle API authentication errors.
*/
  private handleAuthError(errorMsg?: any) {
    localStorage.clear();
    sessionStorage.clear();
    if (!this.isDialogActive) {
      this.isDialogActive = true;
      let dialogRef = this.dialog.open(AlertDialogComponent, {
        data: { msg: errorMsg ?? 'Session Got Expired!', type: 'hideCancel' },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isDialogActive = false;
          this.loaderHandler.toggleLoader(0);
          this.router.navigate(['/login']);
          window.location.reload();
        }
      });
    }
  }
}